import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
  state: {
    eUserInfo:'',
    type: '',
    company_id: '',
    company_ic: '',
    server_address: '',
    delivererUserId: '',
    deliverData: {},
    fetchData: {},
    apitoken: '',
    wsMsg:{},
    fixedAdsPause: false,
    // 信报箱
    mail_type: '',
    mail_oType: '',
    mail_index: 1,
    mail_time: '',
    mail_senderId: '',
    mail_sendWay: '',
    mail_deliver: {},
    mail_box: '',
    //办公寄存柜
    officeLocker_loginInfo: '',
    officeLocker_stepInfo: {},
    officeLocker_deviceInfo: {},
    officeLocker_isSave: false,
    officeLocker_randomSize: '',
    officeLocker_openInfo: {},
    //商城系统
    ECMall_companyInfo: {},
    ECMall_activeGoods: {},
    ECMall_pageSource: '',
    ECMall_timeEnd: false,
    ECMall_warningData: {},

    isShowRBot: true,

    onLine:false,//网络是否连通
    scrWidth: 1920,//屏幕宽度，默认1920

    overTime:0,

  },
  mutations: {
    // 屏幕宽度
    scrWidth: function (state, value) {
      state.scrWidth = value
    },
    // 网络状态
    onLine: function (state, value) {
      state.onLine = value
    },
    // 登录成功后返回信息，token，显示页面等
    eUserInfo: function (state, value) {
      state.eUserInfo = value
    },
    // 存件用户类型（'staff'表示员工，'express'表示快递员）
    type(state, value) {
      state.type = value
    },
    // 公司id
    company_id(state, value) {
      state.company_id = value
    },
    // 公司简称（与公司id性质相同，唯一性）
    company_ic(state, value) {
      state.company_ic = value
    },
    // mqtt的ip地址
    server_address (state, value) {
      state.server_address = value
    },
    // 投递者user_id
    delivererUserId(state, value) {
      state.delivererUserId = value
    },
    // 投递参数
    deliverData(state, value) {
      state.deliverData = value
    },
    // 取件参数
    fetchData(state, value) {
      state.fetchData = value
    },
    // 身份认证apitoken
    apitoken(state, value) {
      state.apitoken = value
    },
    // 固定广告是否暂停
    fixedAdsPause(state, value){
      state.fixedAdsPause = value
    },
    
    /**信报箱 */
    // 存件用户类型（'staff'表示员工，'express'表示快递员）
    mail_type (state, value) {
      state.mail_type = value
    },
    // 用户操作类型
    mail_oType (state, value) {
      state.mail_oType = value
    },
    // 操作的流程index
    mail_index (state, value) {
      state.mail_index = value
    },
    // 倒计时时间
    mail_time (state, value) {
      state.mail_time = value
    },
    // 微信扫码登录user_id
    mail_senderId (state, value) {
      state.mail_senderId = value
    },
    // 登录方式
    mail_sendWay (state, value) {
      state.mail_sendWay = value
    },
    // 信报箱投递数据
    mail_deliver (state, value) {
      state.mail_deliver = value
    },
    // 信报箱投递箱格结果
    mail_box(state, value) {
      state.mail_box = value
    },
    

    /* 办公寄存柜 */
    // 当前登录信息（登录方式及相关信息）
    officeLocker_loginInfo(state, value) {
      state.officeLocker_loginInfo = value
    },
    // 步骤条信息（index当前步骤，step所有步骤）
    officeLocker_stepInfo(state, value) {
      state.officeLocker_stepInfo = value
    },
    // 设备信息
    officeLocker_deviceInfo(state, value) {
      state.officeLocker_deviceInfo = value
    },
    // 专柜专用存物/取物类型
    officeLocker_isSave(state, value) {
      state.officeLocker_isSave = value
    },
    // 随机箱格存物选择的箱格大小
    officeLocker_randomSize(state, value) {
      state.officeLocker_randomSize = value
    },
    // 打开箱子信息
    officeLocker_openInfo(state, value) {
      state.officeLocker_openInfo = value
    },

    /* 商城系统 */
    // 公司信息
    ECMall_companyInfo(state, value) {
      state.ECMall_companyInfo = value
    },
    // 当前选中操作的书籍信息
    ECMall_activeGoods(state, value) {
      state.ECMall_activeGoods = value
    },
    // 跳转的上一页面来源
    ECMall_pageSource(state, value) {
      state.ECMall_pageSource = value
    },
    // 值有切换变化，说明倒计时结束
    ECMall_timeEnd(state, value) {
      state.ECMall_timeEnd = value
    },
    // 预警数据
    ECMall_warningData(state, value) {
      state.ECMall_warningData = value
    },

    // 右下角底部固定内容是否显示
    isShowRBot(state, value) {
      state.isShowRBot = value
    },

    // websocket返回数据
    wsMsg(state, value) {
      state.wsMsg = value
    },

    //E站
		// 超时
		overTime(state, value) {
		  state.overTime = value
		},
  }

})




// WEBPACK FOOTER //
// ./src/store/index.js